import {
  CalendarDays as CalendarDaysIcon,
  ClipboardList as ClipboardListIcon,
  X as CloseIcon,
  GitCompareArrows,
  Home as HomeIcon,
  LayoutGrid as LayoutGridIcon,
  ListTodo as ListTodoIcon,
  UserPlus as UserPlusIcon,
  Users as UsersIcon,
} from "lucide-react";
import { useState, useEffect } from "react";
import { AiOutlineApi } from "react-icons/ai";
import { FaRegClock, FaTasks, FaWhatsapp } from "react-icons/fa";
import { FiActivity, FiLink } from "react-icons/fi";
import { GoDotFill } from "react-icons/go";
import { GrDocumentText } from "react-icons/gr";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import {
  LuDatabaseBackup,
  LuMessageSquare,
  LuTicketPercent,
  LuUserCheck,
  LuUserRoundPlus,
} from "react-icons/lu";
import { MdHistory, MdOutlinePeopleAlt, MdOutlineToday, MdOutlineAnalytics } from "react-icons/md";
import { RiApps2AddLine, RiUserSettingsLine } from "react-icons/ri";
import { MdOutlineDocumentScanner } from "react-icons/md";
import {
  TbCalendarClock,
  TbDatabaseShare,
  TbDeviceDesktopCode,
  TbFileInvoice,
  TbFolderCode,
  TbMapSearch,
  TbReportAnalytics,
  TbReportSearch,
  TbTextScan2,
} from "react-icons/tb";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { BsDatabaseAdd, BsFiletypeExe } from "react-icons/bs";
import Mainlogo from "../../Image/Main_logo.png"; // Replace with your actual image path
import { HiOutlineDocumentCheck, HiOutlineInboxArrowDown } from "react-icons/hi2";
import { MdAddTask } from "react-icons/md";
import { ImProfile } from "react-icons/im";
import { TbChartInfographic } from "react-icons/tb";
import "../../Layout/Layout.css";
import { IoTimerOutline } from "react-icons/io5";
import { GrDocumentUpload } from "react-icons/gr";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const pathname = location.pathname;

  const { LoginData, isdata } = useSelector((state) => state.auth);

  const role = LoginData?.data?.Role;

  const isMain = isdata?.data?.IsMain;


  // const [taskMenuOpen, setTaskMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const [openSubDropdown, setOpenSubDropdown] = useState(null);

  const createNavLink = (item) => {
    const isActive = pathname === item.href;
    return (
      <NavLink
        key={item.name}
        to={item.href}
        className={`flex items-center space-x-3 p-2 rounded-lg transition-colors duration-200 hover:bg-[#FFFFFF33] ${isActive ? "sidebar_active font-semibold" : "font-normal"
          }`}
        onClick={() => {
          if (window.innerWidth < 1024) toggleSidebar();
        }}
      >
        {item.icon}
        <span className="truncate relative group">
          {item.name}
          <span className="absolute left-full ml-2 whitespace-nowrap bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-50">
            {item.name}
          </span>
        </span>
      </NavLink>
    );
  };

  let navItems = [];

  // const taskManagementItems = [];

  if (role === "owner") {
    navItems = [
      {
        name: "Task Management",
        isDropdown: true,
        icon: <ClipboardListIcon size={22} />,
        items: [
          { name: "Home", href: "/", icon: <LayoutGridIcon size={20} /> },
          {
            name: "Party call details",
            href: "/Partycalldetails",
            icon: <HomeIcon size={20} />,
          },
          {
            name: "Task Master",
            href: "/taskmaster",
            icon: <ClipboardListIcon size={20} />,
          },
          {
            name: "Sub Task",
            href: "/subtask",
            icon: <ListTodoIcon size={20} />,
          },
          {
            name: "Show All Task",
            href: "/ShowAllTask",
            icon: <LayoutGridIcon size={20} />,
          },
          // === REPORTS SUB-DROPDOWN INSIDE TASK MANAGEMENT ===
          {
            name: "Reports",
            isSubDropdown: true,
            icon: <TbReportAnalytics size={20} />,
            items: [
              {
                name: "Emp Profile",
                href: "/EmpProfile",
                icon: <ImProfile size={20} />,
              },
              {
                name: "Daily Report",
                href: "/DailyReport",
                icon: <MdOutlineToday size={17} />,
              },
              {
                name: "Monthly Report",
                href: "/MonthlyReport",
                icon: <CalendarDaysIcon size={17} />,
              },
              {
                name: "Emp Productivity",
                href: "/TaskReport",
                icon: <TbReportSearch size={18} />,
              },
              {
                name: "Emp Work Status",
                href: "/TaskDetail",
                icon: <HiOutlineDocumentCheck size={18} />,
              },

            ],
          },
          // ===================================================
          {
            name: "Daily Work Verification",
            href: "/TaskTimeingReport",
            icon: <IoTimerOutline size={20} />,
          },
          {
            name: "Inhouse RND",
            href: "/InhouseRnd",
            icon: <FaTasks size={20} />,
          },
          {
            name: "Assign Task",
            href: "/AssignTask",
            icon: <MdAddTask size={20} />,
          },

          {
            name: "Add Member",
            href: "/AddMember",
            icon: <UserPlusIcon size={20} />,
          },
          {
            name: "Employee Details",
            href: "/EmpOldDetails",
            icon: <RiUserSettingsLine size={20} />,
          },
          {
            name: "Show All Member",
            href: "/ShowAllMember",
            icon: <UsersIcon size={20} />,
          },
          {
            name: "Add Customer",
            href: "/AddCustomer",
            icon: <UserPlusIcon size={20} />,
          },
          {
            name: "Show All Customers",
            href: "/ShowAllCustomers",
            icon: <UsersIcon size={20} />,
          },
          {
            name: "Chat Management",
            href: "/owner-chat",
            icon: <LuMessageSquare size={20} />,
          },
        ],
      },
      {
        name: "Leave Management",
        isDropdown: true,
        icon: <TbCalendarClock size={22} />,
        items: [
          {
            name: "Leave Inbox",
            href: "/OwnerLeaveInbox",
            icon: <HiOutlineInboxArrowDown size={20} />,
          },
          {
            name: "Employee History",
            href: "/EmployeeHistory",
            icon: <MdHistory size={20} />,
          },
          {
            name: "Attendance Corrections",
            href: "/AttendanceCorrections",
            icon: <LuMessageSquare size={20} />,
          },
          {
            name: "Payroll",
            href: "/Payroll",
            icon: <TbChartInfographic size={20} />,
          },
          {
            name: "Workforce Dashboard",
            href: "/AttendanceDashboard",
            icon: <MdOutlineAnalytics size={20} />,
          },
        ],
      },
      {
        name: "Whatsapp Panel",
        isDropdown: true,
        icon: <FaWhatsapp size={22} />,
        items: [
          {
            name: "Client",
            isSubDropdown: true,
            icon: <MdOutlinePeopleAlt size={22} />,
            items: [
              {
                name: "View Client",
                href: "/View_Client",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "WP Registration",
            isSubDropdown: true,
            icon: <LuUserRoundPlus size={22} />,
            items: [
              {
                name: "Wp Registration",
                href: "/WhatsApp_Registration",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Wp Registation",
                href: "/View_WpRegistration",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Client Detail",
                href: "/WpSetupDetail",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Slab",
            isSubDropdown: true,
            icon: <LuTicketPercent size={22} />,
            items: [
              {
                name: "Slab",
                href: "/Slab",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Slab Detail",
                href: "/Slab_Detail",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Log Report",
            href: "/LogReport",
            icon: <TbReportAnalytics size={22} />,
          },
          {
            name: "WP Api Setup",
            isSubDropdown: true,
            icon: <AiOutlineApi size={22} />,
            items: [
              {
                name: "WP Api Main",
                href: "/WpSetup_Main",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "WP Api Details",
                href: "/WpSetup_Details",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Doc Link Setup",
            isSubDropdown: true,
            icon: <FiLink size={19} />,
            items: [
              {
                name: "Doc Link Main",
                href: "/DocumentLink_main",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "DT Link Details",
                href: "/DocumentLink_Details",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Template",
            isSubDropdown: true,
            icon: <GrDocumentText size={20} />,
            items: [
              {
                name: "Add Template",
                href: "/Add_Template",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Template",
                href: "/View_Template",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Project",
            href: "/Project",
            icon: <TbFolderCode size={22} />,
          },
          {
            name: "Data Transfer",
            href: "/DataTransfer",
            icon: <TbDatabaseShare size={22} />,
          },
        ],
      },
      {
        name: "Registration",
        isDropdown: true,
        icon: <RiApps2AddLine size={22} />,
        items: [
          {
            name: "EXE Registration",
            isSubDropdown: true,
            icon: <TbDeviceDesktopCode size={22} />,
            items: [
              {
                name: "Add Registration",
                href: "/Add_Registration",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Registration",
                href: "/View_Registration",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Version",
            isSubDropdown: true,
            icon: <GitCompareArrows size={20} />,
            items: [
              {
                name: "Add Version",
                href: "/Add_Version",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Version",
                href: "/View_Version",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
        ],
      },
      {
        name: "Gemini OCR",
        isDropdown: true,
        icon: <TbTextScan2 size={22} />,
        items: [
          {
            name: "OCR Analytics",
            href: "/OCR_Dashboard",
            icon: <TbReportAnalytics size={22} />,
          },
          {
            name: "OCR Plan",
            href: "/Ocr_Plan",
            icon: <MdOutlineDocumentScanner size={22} />,
          },
          {
            name: "Api Logs",
            isSubDropdown: true,
            icon: <AiOutlineApi size={22} />,
            items: [
              {
                name: "Inward Logs",
                href: "/Inward_Logs",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Delivery Logs",
                href: "/Delivery_Logs",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Combined Logs",
                href: "/Combined_Logs",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Sign Copy Receive",
                href: "/SignCopyRcv",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
        ],
      },
      {
        name: "DB & EXE Update",
        isDropdown: true,
        icon: <LuDatabaseBackup size={22} />,
        items: [
          {
            name: "DataBase Update",
            href: "/DbUpdate",
            icon: <BsDatabaseAdd size={22} />,
          },
          {
            name: "Exe Update",
            href: "/ExeUpdate",
            icon: <BsFiletypeExe size={22} />,
          },
          {
            name: "Exel Update",
            href: "/ExelUpdate",
            icon: <GrDocumentUpload size={20} />,
          },
        ],
      },
      {
        name: "Einvoice & Eway Bill",
        isDropdown: true,
        icon: <TbFileInvoice size={22} />,
        items: [
          {
            name: "Setup Main",
            href: "/Einvoice_Eway_Setup_Main",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Setup Details",
            href: "/Einvoice_Eway_Setup_Details",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Setup Registration",
            href: "/Einvoice_Eway_Setup_Registration",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "E-Invoice & E-Way Log",
            href: "/EInvoice_Eway_Log",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Invoice & Way Response",
            href: "/EInvoice_Eway_Response",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "GSTIN Setup",
            href: "/GstIn_Setup",
            icon: <GoDotFill size={18} />,
          }
        ],
      },
      {
        name: "GeoResolver",
        href: "/GeoResolver_Setup",
        icon: <TbMapSearch size={22} />,
      },
      {
        name: "Employee Document",
        isDropdown: true,
        icon: <GrDocumentText size={22} />,
        items: [
          {
            name: "Internship Offer Letter",
            href: "/InternshipOfferLetter",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Internship Completion Letter",
            href: "/InternshipCompletionLetter",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Job Offer Letter",
            href: "/JobOfferLetter",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Bond Template",
            href: "/Bond_template",
            icon: <GoDotFill size={18} />,
          },
        ],
      },
      {
        name: "Table Master",
        isDropdown: true,
        icon: <TbDatabaseShare size={22} />,
        items: [
          {
            name: "Projects Master",
            href: "/ProjectsMaster",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Type Master",
            href: "/TypeMaster",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Module Master",
            href: "/ModuleMaster",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Table Master",
            href: "/TableMaster",
            icon: <GoDotFill size={18} />,
          },
        ],
      }
    ];
  } else if (role === "management") {
    navItems = [
      {
        name: "Task Management",
        isDropdown: true,
        icon: <ClipboardListIcon size={22} />,
        items: [
          { name: "Home", href: "/", icon: <LayoutGridIcon size={20} /> },
          {
            name: "Party call details",
            href: "/Partycalldetails",
            icon: <HomeIcon size={20} />,
          },
          {
            name: "Main Task",
            href: "/MainTask",
            icon: <ListTodoIcon size={22} />,
          },
          {
            name: "Task Master",
            href: "/taskmaster",
            icon: <FaTasks size={18} />,
          },
          {
            name: "Sub Task",
            href: "/SubTask",
            icon: <ListTodoIcon size={22} />,
          },
          {
            name: "Sub Task Master",
            href: "/subtaskmaster",
            icon: <FaTasks size={18} />,
          },
          {
            name: "Customer Request",
            href: "/CustomerReq",
            icon: <UsersIcon size={20} />,
          },
          {
            name: "Assign Task",
            href: "/AssignTask",
            icon: <MdAddTask size={20} />,
          },
          {
            name: "Show All Task",
            href: "/ShowAllTask",
            icon: <LayoutGridIcon size={20} />,
          },
          // === REPORTS SUB-DROPDOWN INSIDE TASK MANAGEMENT ===
          {
            name: "Reports",
            isSubDropdown: true,
            icon: <TbReportAnalytics size={20} />,
            items: [
              {
                name: "Emp Profile",
                href: "/EmpProfile",
                icon: <ImProfile size={20} />,
              },
              {
                name: "Daily Report",
                href: "/DailyReport",
                icon: <MdOutlineToday size={17} />,
              },
              {
                name: "Monthly Report",
                href: "/MonthlyReport",
                icon: <CalendarDaysIcon size={17} />,
              },
              {
                name: "Emp Productivity",
                href: "/TaskReport",
                icon: <TbReportSearch size={18} />,
              },
              {
                name: "Emp Work Status",
                href: "/TaskDetail",
                icon: <HiOutlineDocumentCheck size={18} />,
              },

            ],
          },
          // ===================================================
          {
            name: "Add Member",
            href: "/AddMember",
            icon: <UserPlusIcon size={20} />,
          },
          {
            name: "Show All Member",
            href: "/ShowAllMember",
            icon: <UsersIcon size={20} />,
          },
          {
            name: "Show All Customers",
            href: "/ShowAllCustomers",
            icon: <UsersIcon size={20} />,
          },
          // {
          //   name: "Payment Details",
          //   href: "/payment-details",
          //   icon: <CreditCardIcon size={20} />,
          // },
          // {
          //   name: "Daily Work",
          //   href: "/DailyWork",
          //   icon: <CalendarDaysIcon size={20} />,
          // },
          {
            name: "Payroll",
            href: "/payroll",
            icon: <TbChartInfographic size={20} />,
          },
          {
            name: "Workforce Dashboard",
            href: "/AttendanceDashboard",
            icon: <MdOutlineAnalytics size={20} />,
          },
        ],
      },
      {
        name: "Whatsapp Panel",
        isDropdown: true,
        icon: <FaWhatsapp size={22} />,
        items: [
          {
            name: "Client",
            isSubDropdown: true,
            icon: <MdOutlinePeopleAlt size={22} />,
            items: [
              {
                name: "View Client",
                href: "/View_Client",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "WP Registration",
            isSubDropdown: true,
            icon: <LuUserRoundPlus size={22} />,
            items: [
              {
                name: "Wp Registration",
                href: "/WhatsApp_Registration",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Wp Registation",
                href: "/View_WpRegistration",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Client Detail",
                href: "/WpSetupDetail",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Slab",
            isSubDropdown: true,
            icon: <LuTicketPercent size={22} />,
            items: [
              {
                name: "Slab",
                href: "/Slab",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Slab Detail",
                href: "/Slab_Detail",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Log Report",
            href: "/LogReport",
            icon: <TbReportAnalytics size={22} />,
          },
          {
            name: "WP Api Setup",
            isSubDropdown: true,
            icon: <AiOutlineApi size={22} />,
            items: [
              {
                name: "WP Api Main",
                href: "/WpSetup_Main",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "WP Api Details",
                href: "/WpSetup_Details",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Doc Link Setup",
            isSubDropdown: true,
            icon: <FiLink size={19} />,
            items: [
              {
                name: "Doc Link Main",
                href: "/DocumentLink_main",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "DT Link Details",
                href: "/DocumentLink_Details",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Template",
            isSubDropdown: true,
            icon: <GrDocumentText size={20} />,
            items: [
              {
                name: "Add Template",
                href: "/Add_Template",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Template",
                href: "/View_Template",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Project",
            href: "/Project",
            icon: <TbFolderCode size={22} />,
          },
          {
            name: "Data Transfer",
            href: "/DataTransfer",
            icon: <TbDatabaseShare size={22} />,
          },
        ],
      },
      {
        name: "Registration",
        isDropdown: true,
        icon: <RiApps2AddLine size={22} />,
        items: [
          {
            name: "Version",
            isSubDropdown: true,
            icon: <GitCompareArrows size={20} />,
            items: [
              {
                name: "Add Version",
                href: "/Add_Version",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Version",
                href: "/View_Version",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
        ],
      },
      {
        name: "Gemini OCR",
        isDropdown: true,
        icon: <TbTextScan2 size={22} />,
        items: [
          {
            name: "OCR Analytics",
            href: "/OCR_Dashboard",
            icon: <TbReportAnalytics size={22} />,
          },
          {
            name: "OCR Plan",
            href: "/Ocr_Plan",
            icon: <MdOutlineDocumentScanner size={22} />,
          },
          {
            name: "Api Logs",
            isSubDropdown: true,
            icon: <AiOutlineApi size={22} />,
            items: [
              {
                name: "Inward Logs",
                href: "/Inward_Logs",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Delivery Logs",
                href: "/Delivery_Logs",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Combined Logs",
                href: "/Combined_Logs",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Sign Copy Receive",
                href: "/SignCopyRcv",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
        ],
      },
    ];
  } else if (
    role === "Delphi Senior Developer" ||
    role === "Web Senior Developer"
  ) {
    navItems = [
      {
        name: "Task Management",
        isDropdown: true,
        icon: <ClipboardListIcon size={22} />,
        items: [
          { name: "Home", href: "/", icon: <LayoutGridIcon size={20} /> },
          {
            name: "Main Task",
            href: "/MainTask",
            icon: <ListTodoIcon size={22} />,
          },
          {
            name: "Task Master",
            href: "/taskmaster",
            icon: <FaTasks size={18} />,
          },
          {
            name: "Sub Task",
            href: "/SubTask",
            icon: <ListTodoIcon size={22} />,
          },
          {
            name: "Sub Task Master",
            href: "/subtaskmaster",
            icon: <FaTasks size={18} />,
          },
          {
            name: "Customer Request",
            href: "/CustomerReq",
            icon: <UsersIcon size={20} />,
          },
          {
            name: "Inhouse RND",
            href: "/InhouseRnd",
            icon: <FaTasks size={20} />,
          },
          {
            name: "Assign Task",
            href: "/AssignTask",
            icon: <MdAddTask size={20} />,
          },
          {
            name: "Show All Task",
            href: "/ShowAllTask",
            icon: <LayoutGridIcon size={20} />,
          },
          {
            name: "Reports",
            isSubDropdown: true,
            icon: <TbReportAnalytics size={20} />,
            items: [
              {
                name: "Emp Profile",
                href: "/EmpProfile",
                icon: <ImProfile size={20} />,
              },
              {
                name: "Daily Report",
                href: "/DailyReport",
                icon: <MdOutlineToday size={17} />,
              },
              {
                name: "Monthly Report",
                href: "/MonthlyReport",
                icon: <CalendarDaysIcon size={17} />,
              },
              {
                name: "Emp Productivity",
                href: "/TaskReport",
                icon: <TbReportSearch size={18} />,
              },
              {
                name: "Emp Work Status",
                href: "/TaskDetail",
                icon: <HiOutlineDocumentCheck size={18} />,
              },
            ],
          },
          {
            name: "Add Member",
            href: "/AddMember",
            icon: <UserPlusIcon size={20} />,
          },
          {
            name: "Show All Member",
            href: "/ShowAllMember",
            icon: <UsersIcon size={20} />,
          },
          {
            name: "Add Customer",
            href: "/AddCustomer",
            icon: <UserPlusIcon size={20} />,
          },
          {
            name: "Show All Customers",
            href: "/ShowAllCustomers",
            icon: <UsersIcon size={20} />,
          },
          ...(isMain === true ? [{
            name: "GM Request",
            href: "/GeneralManagerRequest",
            icon: <GrDocumentUpload size={20} />
          }] : [{
            name: "Leave Request",
            href: "/ProjectManagerRequest",
            icon: <GrDocumentUpload size={20} />
          }]),
          {
            name: "Payroll",
            href: "/Payroll",
            icon: <TbChartInfographic size={20} />,
          },
          {
            name: "Workforce Dashboard",
            href: "/AttendanceDashboard",
            icon: <MdOutlineAnalytics size={20} />,
          },
          {
            name: "Report",
            href: "/Report",
            icon: <CalendarDaysIcon size={20} />,
          },
        ],
      },
      {
        name: "Whatsapp Panel",
        isDropdown: true,
        icon: <FaWhatsapp size={22} />,
        items: [
          {
            name: "Client",
            isSubDropdown: true,
            icon: <MdOutlinePeopleAlt size={22} />,
            items: [
              {
                name: "View Client",
                href: "/View_Client",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "WP Registration",
            isSubDropdown: true,
            icon: <LuUserRoundPlus size={22} />,
            items: [
              {
                name: "Wp Registration",
                href: "/WhatsApp_Registration",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Wp Registation",
                href: "/View_WpRegistration",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Client Detail",
                href: "/WpSetupDetail",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Slab",
            isSubDropdown: true,
            icon: <LuTicketPercent size={22} />,
            items: [
              {
                name: "Slab",
                href: "/Slab",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Slab Detail",
                href: "/Slab_Detail",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Log Report",
            href: "/LogReport",
            icon: <TbReportAnalytics size={22} />,
          },
          {
            name: "WP Api Setup",
            isSubDropdown: true,
            icon: <AiOutlineApi size={22} />,
            items: [
              {
                name: "WP Api Main",
                href: "/WpSetup_Main",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "WP Api Details",
                href: "/WpSetup_Details",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Doc Link Setup",
            isSubDropdown: true,
            icon: <FiLink size={19} />,
            items: [
              {
                name: "Doc Link Main",
                href: "/DocumentLink_main",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "DT Link Details",
                href: "/DocumentLink_Details",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Template",
            isSubDropdown: true,
            icon: <GrDocumentText size={20} />,
            items: [
              {
                name: "Add Template",
                href: "/Add_Template",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Template",
                href: "/View_Template",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Project",
            href: "/Project",
            icon: <TbFolderCode size={22} />,
          },
          {
            name: "Data Transfer",
            href: "/DataTransfer",
            icon: <TbDatabaseShare size={22} />,
          },
        ],
      },
      {
        name: "Registration",
        isDropdown: true,
        icon: <RiApps2AddLine size={22} />,
        items: [
          {
            name: "EXE Registration",
            isSubDropdown: true,
            icon: <TbDeviceDesktopCode size={22} />,
            items: [
              {
                name: "Add Registration",
                href: "/Add_Registration",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Registration",
                href: "/View_Registration",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
          {
            name: "Version",
            isSubDropdown: true,
            icon: <GitCompareArrows size={20} />,
            items: [
              {
                name: "Add Version",
                href: "/Add_Version",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "View Version",
                href: "/View_Version",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
        ],
      },
      {
        name: "Gemini OCR",
        isDropdown: true,
        icon: <TbTextScan2 size={22} />,
        items: [
          {
            name: "OCR Analytics",
            href: "/OCR_Dashboard",
            icon: <TbReportAnalytics size={22} />,
          },
          {
            name: "OCR Plan",
            href: "/Ocr_Plan",
            icon: <MdOutlineDocumentScanner size={22} />,
          },
          {
            name: "Api Logs",
            isSubDropdown: true,
            icon: <AiOutlineApi size={22} />,
            items: [
              {
                name: "Inward Logs",
                href: "/Inward_Logs",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Delivery Logs",
                href: "/Delivery_Logs",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Combined Logs",
                href: "/Combined_Logs",
                icon: <GoDotFill size={18} />,
              },
              {
                name: "Sign Copy Receive",
                href: "/SignCopyRcv",
                icon: <GoDotFill size={18} />,
              },
            ],
          },
        ],
      },
      {
        name: "DB & EXE Update",
        isDropdown: true,
        icon: <LuDatabaseBackup size={22} />,
        items: [
          {
            name: "DataBase Update",
            href: "/DbUpdate",
            icon: <BsDatabaseAdd size={22} />,
          },
          {
            name: "Exe Update",
            href: "/ExeUpdate",
            icon: <BsFiletypeExe size={22} />,
          },
          {
            name: "Exel Update",
            href: "/ExelUpdate",
            icon: <GrDocumentUpload size={20} />,
          },
        ],
      },
      {
        name: "Einvoice & Eway Bill",
        isDropdown: true,
        icon: <TbFileInvoice size={22} />,
        items: [
          {
            name: "Setup Main",
            href: "/Einvoice_Eway_Setup_Main",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Setup Details",
            href: "/Einvoice_Eway_Setup_Details",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Setup Registration",
            href: "/Einvoice_Eway_Setup_Registration",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "E-Invoice & E-Way Log",
            href: "/EInvoice_Eway_Log",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Invoice & Way Response",
            href: "/EInvoice_Eway_Response",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "GSTIN Setup",
            href: "/GstIn_Setup",
            icon: <GoDotFill size={18} />,
          }
        ],
      },
      {
        name: "GeoResolver",
        href: "/GeoResolver_Setup",
        icon: <TbMapSearch size={22} />,
      },
      {
        name: "Table Master",
        isDropdown: true,
        icon: <TbDatabaseShare size={22} />,
        items: [
          {
            name: "Projects Master",
            href: "/ProjectsMaster",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Type Master",
            href: "/TypeMaster",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Module Master",
            href: "/ModuleMaster",
            icon: <GoDotFill size={18} />,
          },
          {
            name: "Table Master",
            href: "/TableMaster",
            icon: <GoDotFill size={18} />,
          },
        ],
      }
    ];
  } else if (
    role === "Delphi Junior Developer" ||
    role === "Web Junior Developer"
  ) {
    navItems = [
      {
        name: "Main Task",
        href: "/",
        icon: <ClipboardListIcon size={20} />,
      },
      {
        name: "Sub Task",
        href: "/SubTask",
        icon: <ListTodoIcon size={20} />,
      },
      {
        name: "Customer Request",
        href: "/CustomerReq",
        icon: <UsersIcon size={20} />,
      },
      {
        name: "Daily Work",
        href: "/DailyWork",
        icon: <CalendarDaysIcon size={20} />,
      },
      {
        name: "Payroll",
        href: "/payroll",
        icon: <TbChartInfographic size={20} />,
      },
      {
        name: "Leave Request",
        href: "/LeaveRequest",
        icon: <GrDocumentUpload size={20} />
      },
      {
        name: "My Request",
        href: "/MyRequest",
        icon: <FiActivity size={20} />
      },
      {
        name: "My Attendance",
        href: "/MyAttendance",
        icon: <LuUserCheck size={20} />
      },
      {
        name: "My Correction",
        href: "/MyCorrection",
        icon: <FaRegClock size={20} />
      }
    ];
  }
  else if (role === "Senior Customer Support") {
    navItems = [
      {
        name: "Main Task",
        href: "/",
        icon: <ClipboardListIcon size={20} />,
      },
      {
        name: "Sub Task",
        href: "/SubTask",
        icon: <ListTodoIcon size={20} />,
      },
      {
        name: "Customer Request",
        href: "/CustomerReq",
        icon: <UsersIcon size={20} />,
      },
      {
        name: "Daily Work",
        href: "/DailyWork",
        icon: <CalendarDaysIcon size={20} />,
      },
      {
        name: "Payroll",
        href: "/payroll",
        icon: <TbChartInfographic size={20} />,
      },
      {
        name: "Workforce Dashboard",
        href: "/AttendanceDashboard",
        icon: <MdOutlineAnalytics size={20} />,
      },
      {
        name: "Leave Request",
        href: "/ProjectManagerRequest",
        icon: <GrDocumentUpload size={20} />
      }
    ];
  }
  else {
    navItems = [
      {
        name: "Main Task",
        href: "/",
        icon: <ClipboardListIcon size={20} />,
      },
      {
        name: "Sub Task",
        href: "/SubTask",
        icon: <ListTodoIcon size={20} />,
      },
      {
        name: "Customer Request",
        href: "/CustomerReq",
        icon: <UsersIcon size={20} />,
      },
      {
        name: "Daily Work",
        href: "/DailyWork",
        icon: <CalendarDaysIcon size={20} />,
      },
      {
        name: "Payroll",
        href: "/payroll",
        icon: <TbChartInfographic size={20} />,
      },
      {
        name: "Leave Request",
        href: "/LeaveRequest",
        icon: <GrDocumentUpload size={20} />
      },
      {
        name: "My Request",
        href: "/MyRequest",
        icon: <FiActivity size={20} />
      },
      {
        name: "My Attendance",
        href: "/MyAttendance",
        icon: <LuUserCheck size={20} />
      },
      {
        name: "My Correction",
        href: "/MyCorrection",
        icon: <FaRegClock size={20} />
      }
    ];
  }

  useEffect(() => {
    if (navItems) {
      navItems.forEach((item) => {
        if (item.isDropdown && item.items) {
          const isMainActive = item.items.some((subItem) => {
            if (subItem.href === pathname) return true;
            if (subItem.isSubDropdown && subItem.items) {
              return subItem.items.some((nested) => nested.href === pathname);
            }
            return false;
          });

          if (isMainActive) {
            setOpenDropdown(item.name);
            item.items.forEach((subItem) => {
              if (subItem.isSubDropdown && subItem.items) {
                const isSubActive = subItem.items.some(
                  (nested) => nested.href === pathname
                );
                if (isSubActive) {
                  setOpenSubDropdown(`${item.name}-${subItem.name}`);
                }
              }
            });
          }
        }
      });
    }
  }, [pathname, role]);

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 Main_sidebar_bg_color text-white w-64 transition-transform duration-300 ease-in-out z-50
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
        lg:${isOpen ? "translate-x-0" : "-translate-x-full"}
        ${isOpen
            ? "lg:sticky lg:top-4 lg:h-[calc(100vh-2rem)] lg:flex lg:rounded-lg lg:m-4 lg:shadow-xl"
            : "lg:hidden"
          }
        flex flex-col`}
      >
        <button
          onClick={toggleSidebar}
          className="absolute top-3 right-3 text-black lg:hidden focus:outline-none hover:bg-[#FFFFFF33] p-1 rounded z-50"
        >
          <CloseIcon size={22} />
        </button>

        <div className="flex-shrink-0 flex items-center justify-center h-24 border-b border-white/10 relative group bg-gradient-to-b from-white/5 to-transparent px-4 py-3">
          <div className="bg-white w-full h-full flex items-center justify-center rounded-xl shadow-lg relative">
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-500 blur-xl bg-white/5 rounded-xl"></div>
            <img
              src={Mainlogo}
              alt="Main Logo"
              className="max-w-[80%] max-h-[80%] w-auto h-auto object-contain drop-shadow-sm hover:drop-shadow-md relative z-10"
            />
          </div>
        </div>

        <div
          className="p-4 pt-2 overflow-y-auto custom-scrollbar"
          style={{ flex: "1 1 0%" }}
        >
          <style>
            {`
              .custom-scrollbar::-webkit-scrollbar {
              width: 5px;
              background-color: #f5f5f5;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
              -webkit-box-shadow: inset transparent;
              background-color: #f5f5f5;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
              background-color: #133a69;
              background-image: -webkit-gradient(
                linear,
                0 0,
                0 100%,
                color-stop(0.5, rgba(225, 225, 225, 0.1)),
                color-stop(0.5, transparent),
                to(transparent)
              );
            }
          `}
          </style>
          <nav className="space-y-2">
            {navItems.map((item, index) => {
              if (item.isDropdown) {
                const isMainOpen = openDropdown === item.name;
                return (
                  <div key={index}>
                    <button
                      onClick={() =>
                        setOpenDropdown(isMainOpen ? null : item.name)
                      }
                      className="flex items-center justify-between w-full p-3 rounded-lg hover:bg-[#FFFFFF33] transition-colors"
                    >
                      <span className="flex items-center space-x-3 font-semibold whitespace-nowrap">
                        {/* <ClipboardListIcon size={20} /> */}
                        {item.icon}
                        <span>{item.name}</span>
                      </span>
                      <span className="ms-1">
                        {isMainOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                      </span>
                    </button>

                    {isMainOpen && (
                      <div className="ml-3 space-y-1 mt-2">
                        {item.items.map((subItem, subIndex) => {
                          if (subItem.isSubDropdown) {
                            const subKey = `${item.name}-${subItem.name}`;
                            const isSubOpen = openSubDropdown === subKey;

                            return (
                              <div key={subIndex}>
                                <button
                                  onClick={() =>
                                    setOpenSubDropdown(
                                      isSubOpen ? null : subKey,
                                    )
                                  }
                                  className="flex items-center justify-between w-full pl-2 pr-3 py-2 rounded-lg hover:bg-[#FFFFFF33] transition-colors"
                                >
                                  <span className="flex items-center space-x-2 font-medium whitespace-nowrap">
                                    {subItem.icon}
                                    <span>{subItem.name}</span>
                                  </span>
                                  <span>
                                    {isSubOpen ? (
                                      <IoIosArrowUp />
                                    ) : (
                                      <IoIosArrowDown />
                                    )}
                                  </span>
                                </button>

                                {isSubOpen && (
                                  <div className="ml-4 mt-2 space-y-1">
                                    {subItem.items.map(
                                      (nestedItem, nestedIndex) =>
                                        createNavLink({
                                          ...nestedItem,
                                          key: nestedIndex,
                                        }),
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          } else {
                            return createNavLink(subItem);
                          }
                        })}
                      </div>
                    )}
                  </div>
                );
              } else {
                return createNavLink(item);
              }
            })}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
